import http from '~/common/http'
export const Model = {
    customer_id: 0,          //客户id
    customer_name: "",       //客户名称
    customer_type: 0,        //客户筛选名称
    product_id: 0,           //产品id
    province_id: 0,          //省份id 
    city_id: 0,              //城市id
    district_id: 0,          //地区id
    start_time: 0,           //开始时间
    end_time: 0,             //结束时间
    user_id: 0,              //业务员id
    salesman: '',            //业务员姓名
    contact_name: "",        //联系人姓名
    mobile: "",               //联系人电话
    qq: "",                   //联系人扣扣
    class_num: "",            //学校班级数
    teacher_num: "",          //学校老师数
    leader_name: "",          //领导人姓名
    leader_job: "",           //领导职位
    leader_mobile: "",        //领导人电话
    source: 0,                //销售线索来源
    productsId: [],            //意向产品id容器
    products: []
};

const TYPE_APPLY = 1;           // 客户主动申请
const TYPE_ONLINE = 2;         //网上搜索结果
const TYPE_INTRODUCE = 3;       //客户介绍
const TYPE_EXHIBITION = 4;      //展会
const TYPE_PROJECT = 5;         //项目招标
const TYPE_OPERATE = 6;         //运营


const TYPE_SCHOOL = 1;          //普通学校
const TYPE_ORGANIZE = 2;        //培训机构
const TYPE_EDUCATION = 3;       //教育局
const TYPE_PERSONAL = 4;        //个人
const TYPE_OTHERS = 5;          //其他
const TYPE_COMPANY = 6;         //公司

const TYPE_PRESIDENT = 1;     //校长
const TYPE_DIRECTER = 2;      //主任


export default {

    // 得到账号模型实例
    getModel() {
        return Model;
    },
    createModel(model) {
        var model = model || this.getModel();
        model.productsId = model.products.map(item => item.product_id +'');
        model.customer_type = model.customer_type.toString();
        model.source = model.source.toString();
        model.province_id = model.province_id || 0;
        model.city_id = model.city_id || 0;
        model.district_id = model.district_id || 0;
        model.leader_job = model.leader_job + ''
        if(model.qq == '0') {
            model.qq = '';
        }
        if(model.class_num == 0) {
            model.class_num = ''
        }
        if(model.teacher_num == 0) {
            model.teacher_num = ''
        }
        if(model.leader_job == 0) {
            model.leader_job = ''
        }
        return model;
    },

    // 得到销售线索来源类型
    getSourceType() {
        return {
            [TYPE_APPLY]: '客户主动申请',
            [TYPE_ONLINE]: '网上搜索',
            [TYPE_INTRODUCE]: '客户介绍',
            [TYPE_EXHIBITION]: '展会',
            [TYPE_PROJECT]: '项目招标',
            [TYPE_OPERATE]: '运营'
        }
    },

    //得到领导职位
    getLeaderType() {
        return {
            [TYPE_PRESIDENT]: '校长',
            [TYPE_DIRECTER]: '主任'
        }
    },

    // 得到客户类型来源
    getCustomerType() {
        return {
            [TYPE_SCHOOL]: '普通学校',
            [TYPE_ORGANIZE]: '培训机构',
            [TYPE_EDUCATION]: '教育局',
            [TYPE_PERSONAL]: '个人',
            [TYPE_OTHERS]: '其他',
            [TYPE_COMPANY]: '公司',
        }
    },

    // 得到客户类型来源
    getCustomerTypeMap() {
        return [
            {label: '普通学校', value: 'school', type: 1},
            {label: '培训机构', value: 'training', type: 2},
            {label: '教育局', value: 'education', type: 3},
            {label: '个人', value: 'independent', type: 4},
            {label: '其他', value: 'other', type: 5},
            {label: '公司', value: 'company', type: 6},
        ];
    },

    // 新增销售线索
    addSaleClue(params) {
        return http.post('/api/sales-leads/create', params);
    },

    //编辑销售线索
    editSaleClue(params) {
        return http.put('/api/sales-leads/update', params);
    },

    // 销售线索筛选
    getList(params) {
        return http.get('/api/sales-leads/index', {
            params: params
        });
    },
    // 申请销售统计筛选
    getAnalyze(params) {
        return http.get('/api/sales-leads/analyze', {
            params: params
        });
    },
    getSaleAnalyze(params){
        return http.get('/api/sales-leads/sale-analyze', {
            params: params
        });
    },

    // 我的销售线索
    getMyList(params) {
        return http.get('/api/sales-leads/my-index', {
            params: params
        })
    },

    //销售线索详情
	getInfo(id) {
		return http.get('/api/sales-leads/view', {
			params: {
				id: id
			}
		});
	},

    // 业务员绑定销售线索
    salesmanBind(params) {
        return http.post('/api/sales-leads/user-bind', params);
    },

    // // 业务员解绑销售线索
    salesmanUnbind(params) {
        return http.post('/api/sales-leads/user-unbind', params);
    },

    // 销售线索绑定客户即关联客户
    customerBind(params) {
        return http.post('/api/sales-leads/customer-bind', params);
    },

    // 销售线索解绑客户
    customerUnbind(params) {
        return http.post('/api/sales-leads/customer-unbind', params);
    },

    // 单个or批量删除销售线索
    deleteClues(leads_ids) {
        return http.delete('/api/sales-leads/delete',{
            data: {
                leads_ids: leads_ids
            }
        })
    },

    //单个or批量转交业务员
    transferSalers(params) {
        return http.put('/api/sales-leads/user-change', params);
    },

    /**
     * 跟进线索
     * @param params
     * @returns {*}
     */
    trace(params) {
        return http.post('/api/sales-leads/trace', params);
    },

    /**
     * 得到线索的跟进记录列表
     * @param id 线索ID
     * @returns {*}
     */
    getTraces(id) {
        return http.get('/api/sales-leads/traces', {
            params: {
                id: id
            }
        });
    },

    /**
     * 得到公共销售线索列表
     * @param params
     * @returns {*}
     */
    getPublicClues(params) {
        return http.get('/api/sales-leads/public-list', {
            params: params
        });
    },

    /**
     * 查询重复
     * @param params
     * @returns {*}
     */
    queryRepeat(params) {
        return http.get('/api/sales-leads/query-repeat', {
            params: params
        });
    },

    getLogs(params) {
        return http.get('/api/sales-leads/logs', {
            params : params
        });
    },

    getMapChart(params) {
        return http.get('/api/sales-leads/map-chart', {
            params: params
        });
    },

    viewMobile(id) {
        return http.get('/api/sales-leads/view-mobile', {
            params: {
                id: id
            }
        });
    },

    // 导入销售线索
    import(params) {
        return http.post('/api/sales-leads/import', params);
    },


    // 线索单位类型统计
    getCustomerTypeCount(params) {
        return http.get('/api/sales-leads/customer-type-count', {
            params: params
        });
    },

    // 线索分配筛选
    getAllocation(params, type) {
        return http.get('/api/sales-leads/allocation-' + type, {
            params: params
        });
    },

    getOriginCountData(params){
        return http.get('/api/sales-leads-count/origin-data', {
            params: params
        });
    },

    getProductCountData(params){
        return http.get('/api/sales-leads-count/product-data', {
            params: params
        });
    },

    getStatusCountData(params){
        return http.get('/api/sales-leads-count/status-data', {
            params: params
        });
    },

    getChannelCountBar(params){
        return http.get('/api/sales-leads-count/channel-bar', {
            params: params
        });
    },
    
    getConvCountFunnel(params){
        return http.get('/api/sales-leads-count/conv-funnel', {
            params: params
        });
    },

    getRealCountSimple(params){
        return http.get('/api/sales-leads-count/real-simple', {
            params: params
        });
    },


    getChangeList(params) {
        return http.get('/api/sales-leads-logs/change-list', {
            params : params
        });
    },
}


// WEBPACK FOOTER //
// ./src/services/SaleClues.js